import { gql } from '@apollo/client';

export const SEARCH_PLACES = gql`
  query SearchPlaces($query: String!) {
    searchPlaces(query: $query) {
      id
      source
      name
      address
      city
      country
      stars
      image
      website
      latitude
      longitude
    }
  }
`;
